import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeType, IncomeTypeDocument } from './types';

export interface UpdateIncomeTypeParams {
  id: string;
  type?: string;
  documents?: IncomeTypeDocument[];
  inUse?: boolean;
}

const updateIncomeType: MutationFunction<
  IncomeType,
  UpdateIncomeTypeParams
> = async ({ id, ...values }) => {
  if (isMockServices()) {
    return await mock({
      id,
      type: values.type ?? 'W-2 Employment Income',
      documents: values.documents ?? [],
      formJson: {},
      inUse: values.inUse ?? true,
    } as IncomeType);
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean; data: IncomeType }>(
    `/income-types/${id}`,
    {
      method: 'PUT',
      body: {
        ...(values.type !== undefined && { type: values.type }),
        ...(values.documents !== undefined && { documents: values.documents }),
        ...(values.inUse !== undefined && { inUse: values.inUse }),
      },
    },
  );

  if (response.data) return response.data.data;
  throw new Error('Failed to update income type');
};

export default updateIncomeType;
